import { Select as MuiSelect, type SelectProps as MuiSelectProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type ReplacedPart = 'slots' | 'input' | 'IconComponent' | 'inputProps' | 'SelectDisplayProps' | 'MenuProps';

type Props<Value> = WithoutStyleOverrides<Omit<MuiSelectProps<Value>, 'variant' | 'native' | ReplacedPart>>;

export function Select<Value = unknown>(props: Props<Value>) {
  return <MuiSelect<Value> {...props} variant="outlined" />;
}

export type { Props as SelectProps };
export type { SelectChangeEvent } from '@mui/material';
